module.exports = {
	"_args": [
		[
			"flow-parser@https://registry.npmjs.org/flow-parser/-/flow-parser-0.21.0.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "flow-parser@>=0.21.0 <0.22.0",
	"_id": "flow-parser@0.21.0",
	"_inCache": true,
	"_location": "/flow-parser",
	"_phantomChildren": {},
	"_requested": {
		"name": "flow-parser",
		"raw": "flow-parser@https://registry.npmjs.org/flow-parser/-/flow-parser-0.21.0.tgz",
		"rawSpec": "https://registry.npmjs.org/flow-parser/-/flow-parser-0.21.0.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/flow-parser/-/flow-parser-0.21.0.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/flow-parser/-/flow-parser-0.21.0.tgz",
	"_shasum": "80b575c7e67c2c6e483ed3aade98a190e2ef7ae9",
	"_shrinkwrap": null,
	"_spec": "flow-parser@https://registry.npmjs.org/flow-parser/-/flow-parser-0.21.0.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "gabe@fb.com",
		"name": "Gabe Levi"
	},
	"bin": {
		"flowparse": "tools/inspect_ast.js",
		"flowvalidate": "tools/js_test_files.js"
	},
	"dependencies": {
		"ast-types": "0.8.14",
		"colors": ">=0.6.2",
		"minimist": ">=0.2.0"
	},
	"description": "JavaScript parser written in OCaml. Produces SpiderMonkey AST",
	"devDependencies": {
		"esprima-fb": "15001.1001.0-dev-harmony-fb"
	},
	"engines": {
		"node": ">=0.4.0"
	},
	"license": "BSD-3-Clause",
	"main": "flow_parser.js",
	"name": "flow-parser",
	"optionalDependencies": {},
	"readme": "# The Flow Parser\n\nThe Flow Parser is a JavaScript parser written in OCaml. It produces an AST that conforms to [SpiderMonkey's Parser API](https://developer.mozilla.org/en-US/docs/Mozilla/Projects/SpiderMonkey/Parser_API) and that mostly matches what [esprima](http://esprima.org/) produces. The Flow Parser can be compiled to native code or can be compiled to JavaScript using [js_of_ocaml](http://ocsigen.org/js_of_ocaml/).\n\n## Building the Flow Parser\n\nBuilding the Flow Parser requires OCaml. Compiling to JavaScript requires js_of_ocaml.\n\n### Initial set up\n\n* [Install opam](https://opam.ocaml.org/doc/Install.html)\n* `opam install js_of_ocaml`\n\n### Building the OCaml Flow Parser library\n\n    make\n    \n### Compiling the Flow Parser to JavaScript\n\n    make js\n\n## Tests\n\nThe Flow Parser's test suite tests the JavaScript version of the parser, so you will need js_of_ocaml installed. The tests and tools also have some node module dependencies, so you will need to run\n\n### Initial set up\n\n* Follow the steps in [Building the Flow Parser](https://github.com/facebook/flow/blob/master/src/parser/README.md#building-the-flow-parser)\n* `npm install`\n\n### Running the Tests\n\n    make test\n",
	"readmeFilename": "README.md",
	"repository": {
		"private": true
	},
	"scripts": {
		"prepublish": "make js",
		"test": "node test/run_tests.js"
	},
	"version": "0.21.0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/flow-parser/package.json
 ** module id = ./node_modules/flow-parser/package.json
 ** module chunks = 0
 **/